import { render, staticRenderFns } from "./RSelect.vue?vue&type=template&id=37721df8&scoped=true"
import script from "./RSelect.vue?vue&type=script&lang=js"
export * from "./RSelect.vue?vue&type=script&lang=js"
import style0 from "./RSelect.vue?vue&type=style&index=0&id=37721df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37721df8",
  null
  
)

export default component.exports